import * as React from 'react';
import {useEffect} from "react";
import API from "../../../app/api";

import moment from 'moment';

import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import makeStyles from "@mui/styles/makeStyles";
import MessageBox from "../../../util/messageBox";

import {setLoading as setLoadingGlobal} from "../../../store/reducers/patient";
import {useDispatch} from "react-redux";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    inputs: {
        display: "flex",
        " & > *": {
            marginRight: 20
        }
    },
    servicePaper: {
        marginBottom: 30, padding: 20
    },
    serviceHeader: {
        padding: "10px",
        fontSize: "20px",
        fontWeight: "bold",
        display: "flex",
        // justifyContent: "space-between",
        gap: '30px',
        alignItems: "center"
    },
    serviceName: {
        display: "flex",
        alignItems: "center",
        minWidth: '300px'
    },
    serviceStatusIcon: {
        marginLeft: 20, width: 10, height: 10, borderRadius: 10
    },
    serviceContainer: {
        display: "flex", justifyContent: "space-between"
    },
    statsItem: {
        marginTop: 20,
    },
    statsName: {
        textDecoration: "underline"
    },
    stopButton: {
        backgroundColor: "#FF6868",
        minWidth: '80px',
        color: "#F2F2F2",
        borderRadius: '6px',
        borderColor: "transparent"
    },
    startButton: {
        backgroundColor: "#A8AFBA",
        minWidth: '80px',
        color: "#F2F2F2",
        borderRadius: '6px',
        borderColor: "transparent"
    }
}));

function ServiceHL7(props) {

    const [serviceStatus, setServiceStatus] = React.useState([]);
    const classes = useStyles();
    const [confirmDialog, setConfirmDialog] = React.useState(false);
    const controller = new AbortController();
    const dispatch = useDispatch();

    const [confirmModalData, setConfirmModalData] = React.useState({
        message: "message",
        value: null

    })

    const doStartStopService = (statServer) => {
        let command = statServer.dockerStatus === 'running' ? 'stop' : 'start';

        setConfirmModalData({
            message: "Do you want to "+ command +" hl7 service?",
            value: statServer
        })
        setConfirmDialog(true);
    }

    const createStats = (statdata) => {
        let dataToDisplay = [];
        if (statdata) {
            for (let d of statdata) {
                let stat = {host: d.host};
                stat.progress = false;
                stat.data = d;
                stat.dockerOk = !d.dockerError && d.dockerNode;
                if (!d.error && !d.dockerError) {
                    stat.statColor = "#1ba504";
                } else {
                    if (d.error && d.dockerError) {
                        stat.statColor = "#ff0000";
                    } else {
                        stat.statColor = "#dbd703";
                    }
                }
                if (d.error) {
                    stat.hl7Status = `Error: ${d.error.message}`;
                    stat.hl7Version = "";
                    stat.hlMode = "";
                } else {
                    stat.hl7Status = `OK: last active  ${moment(Number(d.status)).format("YYYY-MM-DD hh:mm:ss")}`;
                    stat.hl7Version = d.version;
                    stat.hlMode = d.mode;
                }
                if (d.dockerError) {
                    stat.dockerStatusText = `Error: ${d.dockerError.message}`;
                    stat.dockerStatus = "error";
                } else {
                    if (d.dockerNode) {
                        stat.dockerStatus = d.dockerNode.State;
                        stat.dockerStatusText = `${d.dockerNode.State} - ${d.dockerNode.Status}`
                    } else {
                        stat.dockerStatusText = "Unknown error"
                        stat.dockerStatus = "error";
                    }
                }


                dataToDisplay.push(stat);
            }
        }
        return dataToDisplay;
    }
    const getServiceStatus = () =>{
        dispatch(setLoadingGlobal(true));
        API.getHl7Stat(controller.signal).then(stats => {
                if(stats) {
                    setServiceStatus(createStats(stats));
                } else {
                    setServiceStatus([])
                }
            })
            .catch(err => {
                console.error(err);

            })
            .finally(() => {
                dispatch(setLoadingGlobal(false));
            });
    }

    useEffect(()=>{
        getServiceStatus();
        return () => {
            controller.abort();
        };
    }, [])


    const renderServiceStat = (service, index) => {
        return ( <Paper className = {classes.servicePaper} key = {index}>
            <div className={classes.serviceHeader}>
                <div className={classes.serviceName}> Hl7 Server ({service.host})
                    <div className={classes.serviceStatusIcon} style={{ background: service.statColor}}> </div>
                </div>

                {!service.progress &&
                    <Button
                        variant="outlined"
                        disabled={!service.dockerOk}
                        onClick={()=>{doStartStopService(service)}}
                        color={service.dockerStatus === 'running'  ? 'error' : 'primary'}
                        className={clsx(service.dockerStatus === 'running'  ? classes.stopButton : classes.startButton)}
                    >
                        {service.dockerStatus === 'running'  ? 'Stop' : 'Start'}
                    </Button>
                }
            </div>
            <Divider/>
            <div className={classes.serviceContainer}>
                <div className={classes.statsItem} style= {{ width: "25%"}}>
                    <div className={classes.statsName}> HL7 status</div>
                    <div>{service.hl7Status}</div>
                </div>
                <div className={classes.statsItem}>
                    <div className={classes.statsName}> HL7 mode</div>
                    <div>{service.hlMode}</div>
                </div>
                <div className={classes.statsItem}>
                    <div className={classes.statsName}>
                        Docker status
                    </div>
                    <div>{service.dockerStatus}</div>
                </div>
                <div className={classes.statsItem}>
                    <div className={classes.statsName}>
                        Docker version
                    </div>
                    <div>{service.hl7Version} </div>
                </div>
            </div>
        </Paper>)
    }


    const doSendCommand = () => {
        setConfirmDialog(false);

        let command = confirmModalData.value.dockerStatus === 'running' ? 'stop' : 'start';
        let node  = confirmModalData.value.data.dockerHost;

        API.sendCommandHl7(command, node, controller.signal).then(res => {
            console.log(res)
                getServiceStatus();
            })
            .catch(err => {

                console.error(err);

            })
            .finally(() => {

            });
    }

    return(<div >
        <MessageBox
            onClose={() => setConfirmDialog(false)}
            title={'Are you sure?'}
            disableSave
            disabled={false}
            message={confirmModalData.message}
            haveAccept={{yes: 'Yes', no: 'No'}}
            onAccept={doSendCommand}
            open={confirmDialog}
        />
        {serviceStatus.map((service, index)=> {
            return renderServiceStat(service, index)
        })}
        </div>)
}
export default ServiceHL7;